<template>
  <div class="home">
    <v-container>
      <v-card class="mt-4 me-lg-5 p-3">
        <h1 class="large">Ressources utilisées</h1>

        <p class="d-flex gap-2 mb-3">
          <v-icon class="opacity-50">{{ mdiInformation }}</v-icon>
          <span>{{ filteredDocs.length }}<span class="opacity-50"> / {{ docs.length }}</span> ressources dans la base RAG</span>
        </p>

        <!-- Filtres -->
        <div class="d-flex flex-wrap gap-2 mb-2 align-items-center">
          <input
            type="text"
            v-model="search"
            placeholder="Rechercher (nom, URL, discipline…)"
            class="form-control"
            style="min-width: 220px; flex: 1 1 220px"
          />

          <select v-model="selectedDiscipline" class="form-select" style="flex: 0 1 220px">
            <option value="">Toutes les disciplines</option>
            <option v-for="d in allDisciplines" :key="d" :value="d">{{ d }}</option>
          </select>

          <select v-model="selectedTheme" class="form-select" style="flex: 0 1 200px">
            <option value="">Toutes les thématiques</option>
            <option v-for="t in allThemes" :key="t" :value="t">{{ t }}</option>
          </select>

          <button v-if="hasFilters" class="btn btn-sm btn-outline-secondary" @click="resetFilters">
            <v-icon size="14">{{ mdiClose }}</v-icon> Réinitialiser
          </button>
        </div>

        <section>
          <ul v-auto-animate class="p-0 list-unstyled">
            <li v-for="(doc, i) in filteredDocs" :key="doc.id || i" class="border-bottom">
              <RessourceLink :doc="doc" />
            </li>
          </ul>
          <p v-if="filteredDocs.length === 0" class="text-center opacity-50 py-4">Aucune ressource ne correspond aux filtres.</p>
        </section>

      </v-card>
    </v-container>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { mdiInformation, mdiClose } from "@mdi/js";
import Papa from "papaparse";
import RessourceLink from "./RessourceLink.vue";

const search = ref("");
const selectedDiscipline = ref("");
const selectedTheme = ref("");
const docs = ref([]);

onMounted(() => {
  const url = new URL("themes_with_dates.csv", window.location.href).href;
  Papa.parse(url, {
    download: true,
    header: true,
    delimiter: ",",
    skipEmptyLines: true,
    complete: (results) => {
      docs.value = results.data.map((d) => ({
        ...d,
        ThemesList: d.Themes ? d.Themes.split(";").map((t) => t.trim()).filter(Boolean) : [],
        imgError: false,
      }));
    },
    error: (err) => console.error("CSV parse error:", err),
  });
});

const allDisciplines = computed(() =>
  [...new Set(docs.value.map((d) => d.Discipline).filter(Boolean))].sort()
);

const allThemes = computed(() =>
  [...new Set(docs.value.flatMap((d) => d.ThemesList))].sort()
);

const hasFilters = computed(
  () => search.value || selectedDiscipline.value || selectedTheme.value
);

const resetFilters = () => {
  search.value = "";
  selectedDiscipline.value = "";
  selectedTheme.value = "";
};

const filteredDocs = computed(() => {
  const q = search.value.trim().toLowerCase();
  return docs.value.filter((doc) => {
    const matchSearch =
      !q ||
      doc.Filename?.toLowerCase().includes(q) ||
      doc.Url?.toLowerCase().includes(q) ||
      doc.Discipline?.toLowerCase().includes(q) ||
      doc.ThemesList?.some((t) => t.toLowerCase().includes(q));
    const matchDiscipline =
      !selectedDiscipline.value || doc.Discipline === selectedDiscipline.value;
    const matchTheme =
      !selectedTheme.value || doc.ThemesList.includes(selectedTheme.value);
    return matchSearch && matchDiscipline && matchTheme;
  });
});
</script>

<style scoped>
</style>
